import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetSystemListResponse } from "./GetSystemListResponse";
import { GetSystemsLookupResponse } from "./GetSystemsLookupResponse";

export const useSystemApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/systems`;

    const { httpGet } = useAuthorizedFetch();

    const getSystemList = async (): Promise<GetSystemListResponse> => {
        return httpGet<GetSystemListResponse>(`${baseUrl}/list`);
    };

    const getSystemsLookup = async (): Promise<GetSystemsLookupResponse> => {
        return httpGet<GetSystemsLookupResponse>(`${baseUrl}/get-lookup`);
    };

    return {
        getSystemList,
        getSystemsLookup
    };
};
